// useCreateContent.ts
import { ref, watch, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { getToken } from '@/api';
import { useVideoStore } from '@/pinia';
import { addChatHistoryRecord, getAppChatHistoryRecordPage } from '@/request/index';
export default function useCreateContent() {
  const creating = ref(false);
  const createLoading = ref(false);
  const audioContent = ref('');
  const aiGenerateWord = ref('');
  const audioContentRef = ref(null);
  const sessionId = ref('');

  const teamAiHistoryLists = ref([]) as any;
  const getTeamAiHistoryLists = () => {
    getAppChatHistoryRecordPage({
      pageIndex: 1,
      pageSize: 100,
    }).then((res) => {
      const { data } = res.data;
      teamAiHistoryLists.value = data.list;
    });
  };

  // 添加文案
  let addChatHistoryRecordFn = (data) => {
    addChatHistoryRecord(data);
  };

  const streamRequest = ({ url, method = 'POST', headers = {}, data = {}, processFn }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            ...headers,
          },
          body: JSON.stringify(data),
        });

        if (!response.body) {
          throw new Error('响应体为空');
        }

        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        let buffer = '' as any;
        let result = '';

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          if (value.includes(`"code":8001`) || value.includes(`"code":500`)) {
            reject(JSON.parse(value));
          }

          buffer += value;
          const strData = buffer.split('data:');
          buffer = strData.pop(); // Keep the last (possibly incomplete) part in the buffer

          for (let i = 0; i < strData.length; i++) {
            const repData = strData[i];
            if (repData && !repData.match(/^\n+$/)) {
              try {
                const newValue = JSON.parse(repData);
                if (newValue.event === 'message_end' || (newValue?.code && newValue.code !== 200)) {
                  if (newValue.code) {
                    return reject(newValue.msg);
                  }
                  return resolve(result); // Resolve the Promise with accumulated result
                }
                // 存储对话
                if (!sessionId.value || sessionId.value !== newValue.sessionId) sessionId.value = newValue.sessionId;
                if (processFn) {
                  result += newValue?.answer || ''; // Accumulate results if no processFn provided
                  processFn(newValue?.answer || ''); // Process each newValue.answer as desired
                } else {
                  result += newValue?.answer || ''; // Accumulate results if no processFn provided
                }
              } catch (error) {
                console.warn('信息转换失败', error);
                console.log('repData', repData);
              }
            }
          }
        }

        resolve(result); // Ensure the promise resolves with the final result
      } catch (error) {
        reject('生成过程中出现错误，请稍后再试');
        console.error('生成错误', error);
      }
    });
  };

  return {
    creating,
    createLoading,
    addChatHistoryRecordFn,
    audioContent,
    aiGenerateWord,
    audioContentRef,
    streamRequest,
    sessionId,
    getTeamAiHistoryLists,
    teamAiHistoryLists,
  };
}
